import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';

import ContractorAuthenticationModal from '../../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../../components/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../../utils/authUtils';
import {  getDeceasedPersonDate, getDeceasedPersonProfileText } from '../../../../utils/profilePhotoUtils';
import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';
import DeceasedPersonProfile from '../../../../components/family-plaza/DeceasedPersonProfile';

const MemorialPostDetailsPC = () => {
  const navigate = useNavigate();
  const [memorialPostData, setMemorialPostData] = useState(null);
  const [enteredPassword, setEnteredPassword] = useState('');
  const [isPasswordCorrect, setIsPasswordCorrect] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/donate/layer-1910.png');
  const handleNavigation = (route) => { navigate(route); };

  // Load profile photo from localStorage on component mount and listen for updates
  useEffect(() => {
    const loadProfilePhoto = () => {
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let customerName = 'default';
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          customerName = personData.customerName || 'default';
        } catch (error) {
          customerName = 'default';
        }
      }
      
      const photoKey = `uploadedProfilePhoto_${customerName}`;
      const uploadedPhoto = localStorage.getItem(photoKey);
      
      if (uploadedPhoto) {
        setProfilePhotoUrl(uploadedPhoto);
      }
    };
    
    loadProfilePhoto();
    
    // Listen for profile photo updates
    const handleProfilePhotoUpdate = (event) => {
      if (event.detail && event.detail.photoUrl) {
        setProfilePhotoUrl(event.detail.photoUrl);
      } else {
        // If no photoUrl in event, reload from localStorage
        loadProfilePhoto();
      }
    };
    
    window.addEventListener('profilePhotoUpdated', handleProfilePhotoUpdate);
    
    return () => {
      window.removeEventListener('profilePhotoUpdated', handleProfilePhotoUpdate);
    };
  }, []);

  // Load memorial post data from localStorage
  useEffect(() => {
    const savedData = localStorage.getItem('selectedMemorialPost');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setMemorialPostData(parsedData);
      } catch (error) {
        console.error('Error parsing memorial post data:', error);
      }
    }
  }, []);

  // Get current user name for display
  const getCurrentUserName = () => {
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        return personData.customerName || '막내딸';
      } catch (error) {
        return '막내딸';
      }
    }
    return '막내딸';
  };

  // Handle password verification
  const handlePasswordSubmit = (passwordToCheck) => {
    const password = passwordToCheck || enteredPassword;
    
    if (memorialPostData && password === memorialPostData.password) {
      setIsPasswordCorrect(true);
    } else {
      setIsPasswordCorrect(false);
    }
  };

  // Handle action buttons
  const handleListButton = () => {
    navigate('/memorial-post-board-list');
  };

  const handleModifyButton = () => {
    if (isPasswordCorrect) {
      navigate('/memorial-post-writing');
    }
  };

  const handleDeleteButton = () => {
    if (isPasswordCorrect && memorialPostData) {
      // Get customer name from localStorage
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let customerName = 'default';
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          customerName = personData.customerName || 'default';
        } catch (error) {
          customerName = 'default';
        }
      }
      
      // Get existing posts and remove the selected post
      const postsKey = `memorialPosts_${customerName}`;
      const existingPosts = localStorage.getItem(postsKey);
      
      if (existingPosts) {
        try {
          const posts = JSON.parse(existingPosts);
          const updatedPosts = posts.filter(post => post.id !== memorialPostData.id);
          localStorage.setItem(postsKey, JSON.stringify(updatedPosts));
          
          // Dispatch event to notify other components
          window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
            detail: {
              customerName: customerName,
              postData: null
            }
          }));
        } catch (error) {
          console.error('Error updating posts:', error);
        }
      }
      
      // Clear the selected post data
      localStorage.removeItem('selectedMemorialPost');
      // Navigate back to the list
      navigate('/memorial-post-board-list');
    }
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // Open photo registration modal after successful authentication
    setShowPhotoModal(true);
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    console.log('Photo uploaded, updating profile photo:', photoUrl.substring(0, 50) + '...');
    // Update profile photo immediately when photo is uploaded
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-post-details-pc page-memorial-post-details-pc announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="사이버추모관" />
      
    
      {/* Main Content */}
      <div className="memorial-post-details-main-content">
        <div className="memorial-post-details-page-content">
          <div className="memorial-post-details-container">
            
            <DeceasedPersonProfile  handlePhotoIconClick={handlePhotoIconClick} />


            {/* Action Tabs Navigation */}
            <div className="memorial-post-details-action-tabs">
              <div className="memorial-post-details-action-tabs-container">
                <ul>
                  <li><Link to="/donate">헌화하기</Link></li>
                  <li><Link to="/memorial-post-board-list" className="active">추모글</Link></li>
                  <li><Link to="/memorial-album-board-list">추모앨범</Link></li>
                </ul>
              </div>
            </div>

            {/* Content Area - Post Details */}
            <div className="memorial-post-details-content-area">
              
              {/* Post Details */}
              <div className="memorial-post-details-form">
                <div className="memorial-post-details-post-header">
                  <div className="memorial-post-details-post-title">
                    <h3>{memorialPostData ? memorialPostData.title : '보고싶은 우리 엄마'}</h3>
                    <FiLock className="memorial-post-details-lock-icon" />
                  </div>
                  <div className="memorial-post-details-post-meta">
                    <span className="memorial-post-details-post-author">{memorialPostData ? (memorialPostData.writerName || getCurrentUserName()) : '막내딸'}</span>
                    <span className="memorial-post-details-post-date">
                      {memorialPostData ? 
                        new Date(memorialPostData.date).toLocaleDateString('ko-KR', { 
                          year: 'numeric', 
                          month: '2-digit', 
                          day: '2-digit' 
                        }).replace(/\. /g, '.').replace(/\.$/, '') 
                        : '2018.05.03'
                      }
                    </span>
                  </div>
                  <div className="memorial-post-details-post-divider"></div>
                </div>
                
                <div className="memorial-post-details-post-content">
                  {memorialPostData ? (
                    <div>
                      {memorialPostData.content.split('\n').map((line, index) => (
                        <React.Fragment key={index}>
                          <p>{line}</p>
                        </React.Fragment>
                      ))}
                    </div>
                  ) : (
                    <>
                      <p>어머니, 맑은 봄날입니다.</p>
                      <p>오늘도 어머니를 생각하며 하루를 시작합니다.</p>
                      <p>어머니가 계시던 그 자리, 그 시간들이 그립습니다.</p>
                      <p>어머니의 따뜻한 손길과 사랑이 그립습니다.</p>
                      <p>보고 싶습니다. 어머니...</p>
                    </>
                  )}
                </div>
                
                <div className="memorial-post-details-form-actions">
                  <button 
                    className="memorial-post-details-list-btn"
                    onClick={handleListButton}
                  >목록</button>
                  <div className="memorial-post-details-password-section">
                    <input 
                      type="password" 
                      className="memorial-post-details-password-input" 
                      placeholder="비밀번호"
                      value={enteredPassword}
                      onChange={(e) => {
                        setEnteredPassword(e.target.value);
                        // Auto-check password as user types
                        if (e.target.value.length > 0) {
                          handlePasswordSubmit(e.target.value);
                        } else {
                          setIsPasswordCorrect(false);
                        }
                      }}
                    />
                  </div>
                  <div className="memorial-post-details-action-buttons">
                    <button 
                      className="memorial-post-details-edit-btn"
                      onClick={handleModifyButton}
                      disabled={!isPasswordCorrect}
                      style={{
                        opacity: isPasswordCorrect ? 1 : 0.5,
                        cursor: isPasswordCorrect ? 'pointer' : 'not-allowed'
                      }}
                    >수정</button>
                    <button 
                      className="memorial-post-details-delete-btn"
                      onClick={handleDeleteButton}
                      disabled={!isPasswordCorrect}
                      style={{
                        opacity: isPasswordCorrect ? 1 : 0.5,
                        cursor: isPasswordCorrect ? 'pointer' : 'not-allowed'
                      }}
                    >삭제</button>
                  </div>
                </div>
              </div>
              
            </div>

          </div>
        </div>
      </div>

      

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialPostDetailsPC; 